<aside>
  <div class="search-input">
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">
          <i class="fal fa-search"></i>
        </span>
      </div>
      <label for="searchmenu" style="display: none"></label>
      <input
        autocomplete="off"
        name="searchmenu"
        id="searchmenu"
        placeholder="{{ 'search' | translate }}"
        #searchInput
        (ngModelChange)="searchInputValueChange($event)"
        [autofocus]="true"
        [(ngModel)]="searchText"
      />
    </div>
  </div>
  <div class="menu-collapsed-button"></div>
  <div class="tabs">
    <div class="aside">
      <div class="aside-inner">
        <nav class="sidebar">
          <ul class="nav">
            <li *ngFor="let item of structuredMenu; let i = index">
              <a
                *ngIf="!item.children && item.show"
                [attr.id]="'item' + item.id"
                (click)="item.component ? openTab(item) : false"
                title="{{ item.title | translate }}"
                klNavDropdown
                klMouseHover
              >
                <i [class]="item.icon" *ngIf="item.icon"></i>
                <span>{{ item.title | translate }}</span>
              </a>
              <a
                *ngIf="item.children && item.show"
                title="{{ item.title | translate }}"
                class="nav-dropdown-toggle"
                klNavDropdown
                klMouseHover
              >
                <i [class]="item.icon"></i>
                <span>{{ item.title | translate }}</span>
              </a>
              <ul
                *ngIf="item.children && item.show"
                class="nav sidebar-subnav level1"
              >
                <li class="sidebar-subnav-header">
                  {{ item.title | translate }}
                </li>
                <li
                  *ngFor="
                    let firstChildren of item.children;
                    let firstIndex = index
                  "
                >
                  <a
                    *ngIf="!firstChildren.children && firstChildren.show"
                    title="{{ firstChildren.title | translate }}"
                    [attr.id]="'firstIndex' + firstChildren.id"
                    (click)="
                      firstChildren.component ? openTab(firstChildren) : false
                    "
                    klNavDropdown
                    klMouseHover
                  >
                    <span>{{ firstChildren.title | translate }}</span>
                  </a>
                  <a
                    *ngIf="firstChildren.children && firstChildren.show"
                    title="{{ firstChildren.title | translate }}"
                    class="nav-dropdown-toggle"
                    klNavDropdown
                    klMouseHover
                  >
                    <span>{{ firstChildren.title | translate }}</span>
                  </a>
                  <ul
                    *ngIf="firstChildren.children && firstChildren.show"
                    class="nav sidebar-subnav level2"
                  >
                    <li
                      *ngFor="
                        let secondChildren of firstChildren.children;
                        let secondIndex = index
                      "
                    >
                      <a
                        *ngIf="!secondChildren.children && secondChildren.show"
                        [attr.id]="'secondIndex' + secondChildren.id"
                        (click)="
                          secondChildren.component
                            ? openTab(secondChildren)
                            : false
                        "
                        title="{{ secondChildren.title | translate }}"
                      >
                        <em
                          class="material-icons"
                          *ngIf="secondChildren.icon"
                          >{{ secondChildren.icon }}</em
                        >
                        <span>{{ secondChildren.title | translate }}</span>
                      </a>
                      <a
                        *ngIf="secondChildren.children && secondChildren.show"
                        title="{{ secondChildren.title | translate }}"
                        class="nav-dropdown-toggle"
                        klNavDropdown
                        klMouseHover
                      >
                        <span>{{ secondChildren.title | translate }}</span>
                      </a>
                      <ul
                        *ngIf="secondChildren.children && secondChildren.show"
                        class="nav sidebar-subnav level3"
                      >
                        <li
                          *ngFor="
                            let thirdChildren of secondChildren.children;
                            let thirdIndex = index
                          "
                        >
                          <a
                            *ngIf="
                              !thirdChildren.children && thirdChildren.show
                            "
                            [attr.id]="'thirdIndex' + thirdChildren.id"
                            (click)="
                              thirdChildren.component
                                ? openTab(thirdChildren)
                                : false
                            "
                            title="{{ thirdChildren.title | translate }}"
                          >
                            <span>{{ thirdChildren.title | translate }}</span>
                          </a>
                          <a
                            *ngIf="thirdChildren.children && thirdChildren.show"
                            title="{{ thirdChildren.title | translate }}"
                            class="nav-dropdown-toggle"
                            klNavDropdown
                            klMouseHover
                          >
                            <span>{{ thirdChildren.title | translate }}</span>
                          </a>
                          <ul
                            *ngIf="thirdChildren.children"
                            class="nav sidebar-subnav level4"
                          >
                            <li
                              *ngFor="
                                let fourthChildren of thirdChildren.children;
                                let fourthIndex = index
                              "
                            >
                              <a
                                *ngIf="!fourthChildren.children"
                                style="margin-left: 25px"
                                [attr.id]="'fourthIndex' + fourthChildren.id"
                                (click)="
                                  fourthChildren.component
                                    ? openTab(fourthChildren)
                                    : false
                                "
                                title="{{ fourthChildren.title | translate }}"
                              >
                                <em
                                  class="material-icons"
                                  *ngIf="fourthChildren.icon"
                                  >{{ fourthChildren.icon }}</em
                                >
                                <span>{{
                                  fourthChildren.title | translate
                                }}</span>
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    <li></li>
                  </ul>
                </li>

                <li></li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <ul *ngIf="searchText" class="filteredMenu" #filteredMenuList>
      <li
        *ngFor="let menuItemMain of filteredMenu2; let i = index"
        [class.active]="i == selectionPosition"
        (click)="openTab(menuItemMain)"
      >
        <span> {{ menuItemMain.title | translate }}</span>
      </li>
    </ul>
    <div *ngIf="searchText && filteredMenu2.length === 0">
      <span> {{ "not_found" | translate }}</span>
    </div>
  </div>
</aside>
